import { http } from 'services';

// Instance - Registration - Subdomain check
// curl "http://192.168.0.15:3000/instance/registration/subdomain-check?subdomain=dc-whatever"
export function subdomainCheck(query, cbSuccess, cbError) {
  http.get(
    'instance/registration/subdomain-check',
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Instance - Professional registration - Email & subdomain check
// curl "http://192.168.0.15:3000/instance/registration/professional/email-subdomain-check?email=test.new%40gmail.com&subdomain=dc-whatever"
export function emailSubdomainCheck(query, cbSuccess, cbError) {
  http.get(
    'instance/registration/professional/email-subdomain-check',
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Instance - Professional registration - Register
// curl -X "POST" "http://192.168.0.15:3000/instance/registration/professional/register" \
//      -H 'Content-Type: application/json; charset=utf-8' \
//      -d $'{
//   "email": "test.new@gmail.com",
//   "subdomain": "dc-new"
// }'
export function professionalRegister(payload, cbSuccess, cbError) {
  http.post(
    'instance/registration/professional/register',
    payload,
    (response) => {
      cbSuccess(response.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Instance - Professional registration - Get subscription options
// curl "http://192.168.0.15:3000/instance/registration/professional/subscription-options?email=test.new%40gmail.com"
export function subscriptionOptions(query, cbSuccess, cbError) {
  http.get(
    'instance/registration/professional/subscription-options',
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      console.log('gate 1', error);
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}


// Instance - Professional registration - Save subscription selection
// curl -X "POST" "http://192.168.0.15:3000/instance/registration/professional/subscription-selection"
export function subscriptionSelection(payload, cbSuccess, cbError) {
  http.post(
    'instance/registration/professional/subscription-selection',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

// Instance - Professional registration - Get final review
// curl "http://192.168.0.15:3000/instance/registration/professional/review?email=test.new%40gmail.com"
export function subscriptionReview(query, cbSuccess, cbError) {
  http.get(
    'instance/registration/professional/review',
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function registrationCheckout(payload, cbSuccess, cbError) {
  http.post(
    'instance/registration/professional/checkout',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function registrationPreCompletion(query, cbSuccess, cbError) {
  http.get(
    'instance/registration/professional/pre-completion',
    query,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function registrationCompletion(payload, cbSuccess, cbError) {
  // this.$auth.register
  http.post(
    'instance/registration/professional/completion',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}

export function registrationResendCompletionToken(payload, cbSuccess, cbError) {
  http.post(
    'instance/registration/professional/resend-completion-token',
    payload,
    (result) => {
      cbSuccess(result.data);
    },
    (error) => {
      const errorParsed = http.defaultError(error);
      cbError(errorParsed.text, errorParsed.status, errorParsed.data);
    },
  );
}




// WEBPACK FOOTER //
// ./src/api/api-instance/api-instance-registration.js